import { motion, useReducedMotion } from 'motion/react'

/**
 * Aparición suave al entrar en viewport. Concentra aquí la animación para que
 * las secciones no repitan la configuración de Motion, y respeta
 * prefers-reduced-motion desactivándola por completo.
 */
function Revelar({ children, retraso = 0, className = '' }) {
  const sinMovimiento = useReducedMotion()

  if (sinMovimiento) return <div className={className}>{children}</div>

  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: '-80px' }}
      transition={{ duration: 0.6, delay: retraso, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </motion.div>
  )
}

export default Revelar
